import { api } from './client';

export const recomendacaoCompraApi = {
  listar: (meses = 3) => api.get(`/recomendacao-compra?meses=${meses}`)
};
